export const PRE_SCHEDULE_CONFIRMATION_CARD_MODAL_ID =
  'CANCEL_PRE_SCHEDULE_CONFIRMATION_MODAL'
